import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

import { messageContentEnum } from "../../models/message-content-enum.model";
import { messageTypeEnum } from "../../models/message-type-enum.model";

@Injectable({
  providedIn: "root",
})
export class MessageService {

  params = new BehaviorSubject<{
    messageType: messageTypeEnum;
    messageContent: string;
    show: boolean;
  }>(undefined);

  makeMessage(
    messageType: messageTypeEnum,
    messageContent: string,
    show = true
  ) {
    this.params.next({
      messageType,
      messageContent,
      show,
    });
  }

  error(messageContent: messageContentEnum) {
    this.makeMessage(messageTypeEnum.ERROR, messageContent);
  }

  errorString(error: string) {
    this.makeMessage(messageTypeEnum.ERROR, error);
  }

  warning(messageContent: messageContentEnum) {
    this.makeMessage(messageTypeEnum.WARNING, messageContent);
  }

  info(messageContent: messageContentEnum) {
    this.makeMessage(messageTypeEnum.INFO, messageContent);
  }

  success(messageContent: messageContentEnum) {
    this.makeMessage(messageTypeEnum.SUCCESS, messageContent);
  }

  close() {
    this.makeMessage(null, null, false);
  }

}
